import { css } from '@emotion/react'

export const link = css`
  display: block;
  text-align: center;
  width: 100%;
  height: 100%;
  overflow: auto;
`
